<!-- 查询计费接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructureForThirdPark"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KNTYVWC",
                "carCode": "粤EXX123",
                "cardCode": "",
                "needPayQrCode": "",
                "parkingCode": "",
                "couponList": [
                    {
                        "couponName": "三小时优惠",
                        "couponCode": "xxxx",
                        "reliefType": "0",
                        "faceValue": "10",
                        "useRule": "",
                        "maxReliefValue": "",
                        "extraProperty": ""
                    }
                ]
            },
            responseCode: {
                "data": {
                    "payValue": 4.00,
                    "parkName": "自动化性能测试停车场",
                    "payQrCode": "",
                    "cardCode": "",
                    "carChargeType": 1,
                    "parkingTime": 8,
                    "parkingCode": "190104164914525039588256",
                    "enterDate": "20190104164914",
                    "carCode": "桂D16256",
                    "parkingFee": 6.0,
                    "discountedValue": 0,
                    "carChargeDesc": "临时车",
                    "otherAttr": {
                        "chargeBillNumber": "2019010416572209697841",
                        "onlineSearch": 1,
                        "traderCouponList": [{
                            "isValid": true,
                            "traderCouponGrantSn": "BWQDN1O4S3P",
                            "traderCouponValue": 1.00
                        }, {
                            "isValid": true,
                            "traderCouponGrantSn": "BWQDN1O4S3O",
                            "traderCouponValue": 1.00
                        }],
                        "payQrCode": "",
                        "timeoutLength": 0,
                        "chargeTime": "2019-01-04 16:57:21",
                        "isCanUse": true,
                        "carChargeType": 1,
                        "end": "20190104165721",
                        "carChargeDesc": "临时车",
                        "parkAmount": 6.0,
                        "begin": "20190104164914"
                    },
                    "paidValue": 0,
                    "parkCode": "2KPKIOSL",
                    "chargeDate": "20190104165721",
                    "currDisValue": 2.00,
                  "traderCouponList": [{
                    "isValid": true,
                    "traderCouponGrantSn": "BWQDN1O4S3P",
                    "traderCouponValue": 1.00
                  }, {
                    "isValid": true,
                    "traderCouponGrantSn": "BWQDN1O4S3O",
                    "traderCouponValue": 1.00
                  }]
                },
                "resultCode": 0,
                "message": "业务成功",
                "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动请求第三方接入系统获取停车费用信息",
                sdkcondition: "cmd=getFeeForThi",
                httpcondition: this.commonUrls.third+"getFeeForThi",
                precondition: "无",
                fitSystem: "第三方停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号，如果不传，则在整个系统按车牌或卡号搜索' },
                        { info1: 'carCode', info2: 'carCode、cardCode、parkingCode、randomCode和userUniqCode五选一', info3: 'String', info4: '车牌编号' },
                        { info1: 'cardCode', info2: 'carCode、cardCode、parkingCode、randomCode和userUniqCode五选一', info3: 'String', info4: '停车卡编号' },
                        { info1: 'parkingCode', info2: 'carCode、cardCode、parkingCode、randomCode和userUniqCode五选一', info3: 'String', info4: '停车流水号' },
                        { info1: 'randomCode', info2: 'carCode、cardCode、parkingCode、randomCode和userUniqCode五选一', info3: 'String', info4: '随机码，无牌车扫码自助进出场时使用。使用该字段查费时，parkCode必填' },
                        { info1: 'userUniqCode', info2: 'carCode、cardCode、parkingCode、randomCode和userUniqCode五选一', info3: 'String', info4: '第三方所属用户的唯一编码，无牌车扫码自助进出场时使用。使用该字段查费时，parkCode必填' },
                        { info1: 'needPayQrCode', info2: '否', info3: 'Integer', info4: '0否，1是' },
                        { info1: 'couponList', info2: '否', info3: 'JsonArray', info4: '查询的优惠列表。第三方优惠列表（带券查费时，如已存在电子券优惠，则电子券默认不参与该次缴费流程），查费时不核销，响应的couponValue表示最终优惠金额。查费时带有该优惠列表，缴费时同样需要该优惠，方能成功缴费。如果查费时，线下认为带券查费和不带券查费费用一样，则不会使用该优惠券，即不返回couponList。' }
                    ]
                }, {
                    titleName: 'couponList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠名称' },
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠编码(第三方根据业务确定)' },
                        { info1: 'reliefType', info2: '是', info3: 'Integer', info4: '减免类型，券类型(0:免费券,1:金额扣减券,车费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算,5:不同计价券,按不同计价规则车费结算)' },
                        { info1: 'faceValue', info2: '是', info3: 'String', info4: '面值，金额填元,折扣填0~100,时间填分钟' },
                        { info1: 'useRule', info2: '否', info3: 'String', info4: '使用规则，0<=${money}&&${money}<=100表示0~100元内可用' },
                        { info1: 'maxReliefValue', info2: '否', info3: 'Decimal', info4: '最大抵扣金额' },
                        { info1: 'extraProperty', info2: '否', info3: 'String', info4: '劵额外属性，JSON字符串，暂不填写' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'cardCode', info2: '是', info3: 'String', info4: '停车卡编号' },
                        { info1: 'enterDate', info2: '是', info3: 'String', info4: 'yyyyMMddHHmmss入场时间' },
                        { info1: 'chargeDate', info2: '是', info3: 'String', info4: 'yyyyMMddHHmmss计费时间' },
                        { info1: 'parkingTime', info2: '是', info3: 'Integer', info4: '停车时长，分钟为单位' },
                        { info1: 'parkingFee', info2: '是', info3: 'Decimal', info4: '此次停车的总费用，单位元' },
                        { info1: 'payValue', info2: '是', info3: 'Decimal', info4: '需缴费金额，单位元' },
                        { info1: 'paidValue', info2: '是', info3: 'Decimal', info4: '此次停车已缴金额，单位元' },
                        { info1: 'discountedValue', info2: '是', info3: 'Decimal', info4: '此次停车已优惠金额，单位元' },
                        { info1: 'currDisValue', info2: '是', info3: 'Decimal', info4: '本次优惠金额(传递的couponList优惠不计入该值)，单位元' },
                        { info1: 'otherAttr', info2: '是', info3: 'JSONObject', info4: '额外信息，缴费时传回，用于扩充其他需要的信息。现有一属性，券列表' },
                        { info1: 'carChargeType', info2: '是', info3: 'Integer', info4: '0混合类型，1临时车，2时间VIP，3储值VIP，4计次VIP，5黑名单，6访客，7预定车位车辆，8共享车位车辆，9红名单，混合类型表示整次停车包括多个类型，如临时车-时间VIP' },
                        { info1: 'carChargeDesc', info2: '是', info3: 'String', info4: 'carChargeType对应具体类型名称如临时车、半年卡、储值卡等混合类型展示格式【类型1】-【类型2】，如临时车-半年卡' },
                        { info1: 'payQrCode', info2: '是', info3: 'Decimal', info4: '支付二维码Base64编码格式' },
                        { info1: 'couponList ', info2: '否', info3: 'JsonArray', info4: '对应查询时的优惠响应（目前只支持传输一个优惠）' },
                        { info1: 'traderCouponList ', info2: '否', info3: 'JsonArray', info4: '电子券优惠' }
                    ]
                },
                {
                    titleName: 'couponList：对应查询时的第三方优惠响应，注意：shouldPayValue没有减去此部分优惠的金额，在缴费时自行扣减',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠名称' },
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠编码' },
                        { info1: 'reliefType', info2: '是', info3: 'int', info4: '减免类型' },
                        { info1: 'faceValue', info2: '是', info3: 'String', info4: '面值' },
                        { info1: 'useRule', info2: '是', info3: 'String', info4: '使用规则' },
                        { info1: 'maxReliefValue', info2: '否', info3: 'Decimal', info4: '最大抵扣金额' },
                        { info1: 'couponValue', info2: '是', info3: 'String', info4: '实际抵扣金额' }
                    ]
                },
                {
                    titleName: 'otherAttr部分参数说明',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'timeoutLength', info2: '否', info3: 'int', info4: '剩余免费时长，单位秒;VEMS2.13级以上版本支持' },
                        { info1: 'traderCouponList', info2: '否', info3: 'JsonArray', info4: '电子券优惠' },
                    ]
                },
                {
                    titleName: 'traderCouponList：对应查询时的电子券优惠响应',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'isValid', info2: '是', info3: 'Boolean', info4: '是否可用' },
                        { info1: 'traderCouponGrantSn', info2: '否', info3: 'JsonArray', info4: '电子券优惠' },
                        { info1: 'traderCouponValue', info2: '否', info3: 'Decimal', info4: '券优惠金额。字段类型视券类型确定' },
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/common/getFeeForThi.vue